<template lang="pug">
    .model-list-gzzoc(ref="list-container")
        logo
        user-nav
        .content
            .title(:class="titleClass")
            .model-area(ref="model-area")
                .eyeball-area(ref="eyeball" v-if="list && list.length")
                    eyeball
                        .iris-c(ref="iris")
                .model-list(v-if="!entrance && list && list.length")
                    .model-item(v-for="(item, index) in list",
                        :class="{disabled: item.status !== 'enable'}",
                        v-itemmove="{index: index, total: list.length}"
                        @mouseenter="showIndex = index"
                        @mouseleave="showIndex = null"
                        ref="item")
                        img.item-img(:src="imageList[index]", :class="index === 1 ? 'item-img-long' : ''")
                        .model-item-menu-box(v-show="showIndex === index")
                            .model-item-menu(v-for="(menu, idx) in item.menus", @click="toModel(menu)")
                                .menu-name {{menu.name}}
                .model-list.entrance-list(v-else)
                    .model-item(v-for="(item, index) in entranceList",
                        @click="toModel(item)"
                        :class="{disabled: item.status !== 'enable'}",
                        v-itemmove="{index: index, total: entranceList.length}"
                        ref="item")
                        img.item-img(:src="entranceImages[index]", :class="index === 1 ? 'item-img-long' : ''")
                        .model-item-menu-box
                            .entrance-name {{item.name}}
                            .entrance-btn {{$t('startPredict')}}
                            //- .model-item-menu(@click="toModel(menu)")
                            //-     .menu-name {{item.name}}
</template>

<script>
import Logo from 'components/logo';
import WavePoints from 'components/wave-points';
import ls from '@/utils/local-storage';
import _ from 'lodash';
import UserNav from 'components/user-nav';
import Eyeball from '@/views/model/components/eyeball';

import eyeIcon from 'public/images/new-model/eye-icon.svg';
import bodyIcon from 'public/images/new-model/body-icon.svg';
import otherIcon from 'public/images/new-model/other-icon.svg';
import ckdIcon from 'public/images/new-model/ckd-icon.png';
import ckdIcon2 from 'public/images/new-model/ckd2-icon.png';
import { log } from 'three';

/**
 * 计算方法同 components/gzzoc-model-basic
 */
function getModelAreaSize () {
    let top = 300;
    let clientHeight = window.document.body.clientHeight;
    let height = Math.max(clientHeight - top, 600);
    return {
        width: height * 2,
        height,
        top,
    };
}
function getUrlParams(url) {
  const paramsRegex = /[?&]+([^=&]+)=([^&]*)/gi;
  const params = {};
  let match;
  while (match = paramsRegex.exec(url)) {
    params[match[1]] = match[2];
  }
  return params;
}

/**
 * model-item位置计算与更新
 * 假设modal-area底部的中点A为圆形的中心，model-item的图片的中心B为model-item的位置中心
 * 先计算A、B连线和垂直方向的夹角α
 * modelItem到左边框的距离 = 圆形半径 + sinα * AB长
 * modelItem到有边框的距离 = 圆形半径 - cosaα * AB长
 */
function updateModalItem (el, index, total, update = false, isCkd = false) {
    let urlParams = getUrlParams(window.location.href) // 临时加的判断
    let modelSize = getModelAreaSize(isCkd);
    let r = modelSize.height;
    let imgWidth = (urlParams.entrance || window.location.origin === 'https://zockids.gzzoc.com') ? 420:220;
    let imgHeight = 174;
    // 1 ~ 5 的夹角分别为 -60、-30、0、30、60
    let tIndex = (total - 1) / 2;
    let angle = (index - tIndex) * 2 * 13;
    function setElPosition (radius,h) {
        let x = r + Math.sin(angle * Math.PI / (isCkd?50:150)) * radius;
        let y = r - Math.cos(angle * Math.PI / 180) * radius;
        let left = (x - imgWidth / 2) + 'px';
        // let top = (y - imgHeight / 2) + 'px';
        let top = `${h}px`;
        el.style.left = left;
        el.style.top = top;
    }
    if (update) {
        // 如果modelItem不是首次渲染，只需要更新modelItem的位置
        el.style.visibility = 'visible';
        setElPosition(r);
    } else {
        // 如果modelItem是首次渲染，则modelItem的初始位置到圆心的中点的距离是2/3个半径，然后在移动到半径处
        el.style.visibility = 'hidden';
        setElPosition(r * 2 / 3);
        setElPosition(r * 2 / 3, 250);
        let delay = '0s';
        let dur = '0.3s';
        el.style.transition = `left ${dur} linear ${delay}, top ${dur} linear ${delay}`;
        setTimeout(() => {
            el.style.visibility = 'visible';
            setElPosition(r, 0);
        // eyeball 的动画 + circle 的动画完成总共需要2s
        // 间隔 0.3s 执行
        }, 1000 * (2 + 0.3 * index));
    }
}
const origin = window.location.origin
export default {
    data () {
        return {
            showIndex: null,
            list: [],
            entranceList: [],
            entrance: (this.$route.query.entrance || window.location.origin === 'https://zockids.gzzoc.com') ? 'CKD' : '',
            imageList: [
                eyeIcon,
                bodyIcon,
                otherIcon,
            ],
            entranceImages: [
                ckdIcon,
                ckdIcon2
            ]
        };
    },
    directives: {
        itemmove: {
            bind (el) {
                el.style.visibility = 'hidden';
            },
            inserted (el, binding) {
                let {index, total} = binding.value;
                updateModalItem(el, index, total, false, true);
            },
            update (el, binding) {
                let {index, total} = binding.value;
                updateModalItem(el, index, total, true);
            }
        }
    },
    components: {
        Logo,
        WavePoints,
        UserNav,
        Eyeball
    },
    mounted () {
        this.resizeThrottle = _.throttle(this.onWindowSizeChange.bind(this), 1000);
        window.addEventListener('resize', this.resizeThrottle);
        this.setModelAreaSize();
        this.getData();
    },
    beforeDestroy () {
        window.removeEventListener('resize', this.resizeThrottle);
        this.resizeThrottle = null;
    },
    methods: {
        getData () {
            this.list = []
			 
            this.$http.get(`mli/predict_model/model_list?entrance=${this.entrance}`).then(resp => {
                let arr = [
                    {menus: [], type: 'eye_model'},
                    {menus: [], type: 'body_model'},
                    {menus: [], type: 'outside_model'}
                ]
                if(!this.entrance) {
                    var data = _.get(resp, 'body.value.data');
                    arr.forEach(item => item.menus = data[item.type])
                    this.list = arr
                } else {
                    const entrances = ['ckd_all', 'ckd_screening']
                    this.entranceList = _.filter(_.get(resp, 'body.value.data.new_entr_model'), item=>_.includes(entrances, item.model_type))
                    console.log(this.entranceList)
                }
            });
        },
        setModelAreaSize () {
            let size = getModelAreaSize();
            let modelArea = this.$refs['model-area'];
            modelArea.style.top = size.top + 'px';
            modelArea.style.width = size.width + 'px';
            modelArea.style.height = size.height + 'px';
            let clientHeight = window.document.clientHeight;
            let newHeight = Math.max(clientHeight, size.height + 350);
            window.document.clientHeight = newHeight;
        },
        onWindowSizeChange () {
            this.setModelAreaSize();
            this.$forceUpdate();
        },
        enterModelItem (event) {
            let target = event.target.parentNode.parentNode;
            let img = target.getElementsByClassName('item-img')[0];
            img.style.transform = 'scale(1.1, 1.1)';
        },
        leaveModelItem (event) {
            let target = event.target.parentNode.parentNode;
            let img = target.getElementsByClassName('item-img')[0];
            img.style.transform = '';
        },
        toModel (model) {
            if (model.status === 'thirdurl' && model.url) { // 非模型情况跳转
                window.open(model.url)
                return
            }
            if (model.status !== 'enable') {
                return;
            }
            if (model.url) {
                window.open(model.url)
                return
            }
            this.$router.push({
                name: 'modelDetail',
                params: {
                    id: model.model_id,
                    type: model.model_type,
                }
            });
        },
    },
    computed: {
        titleClass () {
            let cls = ls.get('lang');
            return {
                'cn': !this.entrance && cls === 'zh-CN',
                'en': !this.entrance && cls === 'en',
                'entrance-cn': this.entrance && cls === 'zh-CN',
                'entrance-en': this.entrance && cls === 'en',
            };
        }
    }
};
</script>
<style lang="sass" scoped>

    @keyframes eyeball-animate
        0%
            top: 100%
        100%
            top: 33.3%
    @keyframes iris-animate
        0%
            width: 0
            height: 0
        100%
            width: 100%
            height: 100%
    .model-list-gzzoc
        background: url(~public/images/gzzoc/bg.jpg) no-repeat fixed center top / cover
        height: 100%
        min-height: 900px
        overflow-y: hidden
        width: 100%
        min-width: 1150px
        padding-bottom: 100px
        position: relative
    .content
        width: 100%
        height: 100%
        margin: 0 auto
        position: absolute
        top: 0
        left: 0
        z-index: 1
        overflow-y: hidden
        .title
            width: 698px
            height: 157px
            position: absolute
            top: 80px
            left: 50%
            transform: translateX(-50%)
            background: url(~public/images/gzzoc/front-title-cn.svg) no-repeat top left / 100% 100%
            &.en
                background-image: url(~public/images/gzzoc/front-title-en.svg)
            &.entrance-cn
                background-image: url(~public/images/gzzoc/front-title-entrance-cn.svg)
            &.entrance-en
                background-image: url(~public/images/gzzoc/front-title-entrance-en.svg)
    .model-area
        // 宽高比恒定为 2 : 1
        width: 1200px
        height: 600px
        position: absolute
        top: 350px
        left: 50%
        transform: translateX(-50%)
    .circle
        width: 100%
        height: 0
        padding-top: 60%
        position: absolute
        top: 0
        left: 0
        svg
            position: absolute
            left: 0
            top: 0
            width: 100%
            height: 100%
    .eyeball-area
        width: 66.67%
        height: 0
        padding-top: 66.67%
        position: absolute
        top: 33.3%
        left: 50%
        transform: translateX(-50%)
        animation: eyeball-animate 1s
        .eyeball-wrapper
            width: 100%
            position: absolute
            top: 0
            left: 0
        .iris-c
            width: 0
            height: 0
            position: absolute
            left: 50%
            top: 50%
            transform: translate(-50%, -50%)
            background: url(~public/images/gzzoc/iris.svg) no-repeat left top / 100% 100%
            mix-blend-mode: screen
            animation: iris-animate 0.8s linear 1s forwards
    .model-list
        width: 100%
        height: 0
        padding-top: 50%
        position: absolute
        top: 0
        left: 0
        .model-item
            position: absolute
            width: 320px
            text-align: center
            cursor: pointer
            // transition: left 1s, top 1s
            .model-item-menu-box
                position: absolute
                top: 205px
                left: 72px
                overflow-y: auto
                max-height: 380px
                &::-webkit-scrollbar
                    width: 6px
                    background: none
                &::-webkit-scrollbar-thumb
                    border-radius: 10px
                    -webkit-box-shadow: inset 0 0 6px rgb(0 0 0 / 30%)
                    background-color: #d9d2d2
                .model-item-menu
                    width: 180px
                    padding: 10px
                    background-image: url("~@/assets/imgs/menu-item-bg.png")
                    background-size: 100% 100%
                    margin:0 auto
                    color: #000535
                    font-weight: bold
                    &:hover
                        background-image: url("~@/assets/imgs/menu-item-bg-hover.png")
                        color: #fff

            .item-img
                width: 220px
                height: 240px
                transition: transform 0.5s
            .item-img-long
                height: 244px
                width: 272px
            .item-title
                font-family: PingFangSC-Semibold
                font-size: 20px
                color: #333333
                letter-spacing: 0.57px
                text-align: center
                margin-top: 16px
            .predict-button
                font-family: PingFangSC-Semibold
                font-size: 14px
                color: #FFFFFF
                text-align: center
                margin-top: 16px
    .entrance-list
        .model-item
            width: 450px
            .model-item-menu-box
                top: 255px
                left: 0
                width: 450px
                overflow: hidden
                .entrance-name
                    color: #333
                    text-align: center
                    font-feature-settings: 'clig' off, 'liga' off
                    font-family: "PingFang SC"
                    font-size: 40px
                    font-style: normal
                    font-weight: 600
                    line-height: 48px
                .entrance-btn
                    margin: 24px auto 0
                    padding: 12px 24px
                    width: 180px
                    justify-content: center
                    align-items: center
                    gap: 4px
                    border-radius: 8px
                    background: linear-gradient(270deg, #0E538B 0%, #3E3D8E 100%)
                    color: #FFF
                    text-align: center
                    font-feature-settings: 'clig' off, 'liga' off
                    font-family: "PingFang SC"
                    font-size: 32px
                    font-style: normal
                    font-weight: 600
                    line-height: 40px
            .item-img
                width: 240px
                height: 240px
</style>
